var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c7399693-f6be-4e80-aa9e-92fe1f7fd0fb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["zz-platform-pages@zhuanzhuan"]={id:"c7399693-f6be-4e80-aa9e-92fe1f7fd0fb"};
      